const CheckBox = () => (
  <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="13" cy="13" r="13" stroke="#C4C4C4" strokeWidth="1" />
  </svg>
)

export default CheckBox
